import "./FreeHotelRevenueAuditNoCostCompleteAnalysis.module.css";
import Header from "@/reusable_sections/Header";
import Audithero from "./sections/Audithero";
import RevenueJourneyLeadForm from "./sections/RevenueJourneyLeadForm";
import RevenueAuditChecklist from "./sections/RevenueAuditChecklist";
import AuditProcess from "./sections/AuditProcess";
import Auditfaq from "./sections/Auditfaq";
import FinalAuditCTA from "./sections/FinalAuditCTA";
import Auditreportpreview from "./sections/Auditreportpreview";
import Footer from "@/reusable_sections/Footer";
export default function FreeHotelRevenueAuditNoCostCompleteAnalysisPage() {
  return <div>
      <Header />
      <Audithero />
      <RevenueJourneyLeadForm />
      <RevenueAuditChecklist />
      <AuditProcess />
      <Auditfaq />
      <Auditreportpreview />
      <FinalAuditCTA />
      <Footer />
    </div>;
}